export const CHANGE_REQUEST_TAB = {
  MAIN_INFORMATION: 'main_information',
  MULTIMEDIA: 'multimedia',
  FILES: 'files',
  DIFFUSION: 'diffusion',
};

export const CHANGE_REQUEST_TABS = [
  CHANGE_REQUEST_TAB.MAIN_INFORMATION,
  CHANGE_REQUEST_TAB.MULTIMEDIA,
  CHANGE_REQUEST_TAB.FILES,
  CHANGE_REQUEST_TAB.DIFFUSION,
];

/**
 * Order of change-request subsections (categories) within each main tab. The UI
 * walks this list and renders only non-null entries from `categoriesByTab[tabId].sections`.
 * Backend can send a dictionary with null for empty sections, same keys.
 *
 * Diffusion: primary payload key is `diffusion_scalar_changes`; `portals` kept for compatibility.
 */
export const CHANGE_REQUEST_SECTION_ORDER = {
  [CHANGE_REQUEST_TAB.MAIN_INFORMATION]: [
    'general',
    'map',
    'address_and_location',
    'custom_tags',
    'cotization',
    'operations_data',
    'basic_data',
    'surface_and_measures',
    'services_additionals_rooms',
    'description',
    'location',
    'custom_attributes',
    'internal_data',
    'promotions_and_benefits',
  ],
  [CHANGE_REQUEST_TAB.MULTIMEDIA]: ['images', 'videos'],
  [CHANGE_REQUEST_TAB.FILES]: ['files', 'documents'],
  [CHANGE_REQUEST_TAB.DIFFUSION]: ['diffusion_scalar_changes', 'portals'],
};

export const ENTITY_TYPE = {
  PROPERTY: 'property',
  DEVELOPMENT: 'development',
};

/** Row lifecycle after supervised review (`changeRequests[].status`). */
export const CHANGE_REQUEST_ROW_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
};

/** `scope` values for POST `/api3/publishable/change-requests/review`. */
export const CHANGE_REQUEST_REVIEW_SCOPE = {
  ALL: 'all',
  IDS: 'ids',
  SECTION: 'section',
};

/** `decision` body field for bulk change-request review. */
export const CHANGE_REQUEST_REVIEW_DECISION = {
  APPROVE: 'approve',
  REJECT: 'reject',
};

/** Stable `categoryId` / section keys from API; drives frontend layout only. */
export const CHANGE_REQUEST_SECTION_CATEGORY_ID = {
  DESCRIPTION: 'description',
  /** Legacy standalone EN section key; still mapped to description compare if present. */
  DESCRIPTION_EN: 'description_en',
  MAP: 'map',
  MULTIMEDIA_IMAGES: 'images',
  MULTIMEDIA_VIDEOS: 'videos',
};

/**
 * `field.label` on each row within the merged `description` section change requests (API).
 * Drives ES vs EN compare textarea labels.
 */
export const CHANGE_REQUEST_DESCRIPTION_FIELD_LABEL = {
  DESCRIPTION: 'description',
  DESCRIPTION_EN: 'description_en',
};

/**
 * How the body of a change-request category is rendered.
 * TABLE: default tabular layout; DESCRIPTION_COMPARE / MAP_COMPARE: custom compares.
 */
export const SECTION_CONTENT_VARIANT = {
  TABLE: 'table',
  DESCRIPTION_COMPARE: 'description_compare',
  MAP_COMPARE: 'map_compare',
};

/** How rows render inside a Multimedia tab category when content is TABLE. */
export const MULTIMEDIA_TABLE_VARIANT = {
  /** Single image, change description, requested by, actions (Figma Images). */
  IMAGES: 'images',
  /** Video rows: video label + field + original + requested + by + actions. */
  VIDEOS: 'videos',
  /** Same as other tabs: field + original + requested + by + actions. */
  DEFAULT: 'default',
};

/** Row-level `kind` for multimedia video change requests. */
export const VIDEO_ITEM_KIND = {
  ADD: 'add',
  REMOVE: 'remove',
  FIELD: 'field',
};

/** Row-level `kind` from API (informational; UI reads `image` / `changeMade`). */
export const MULTIMEDIA_ITEM_KIND = {
  REORDER: 'reorder',
  ADD: 'add',
  FIELD: 'field',
  EDIT: 'edit',
  REMOVE: 'remove',
  COVER: 'cover',
};

/** `changeRequests[].image.kind` — drives preview layout in MultimediaImageCell. */
export const IMAGE_SLOT_KIND = {
  SINGLE: 'single',
  REMOVED: 'removed',
  STRIP: 'strip',
  PAIR: 'pair',
};

/** `changeRequests[].changeMade.kind` — drives ChangeMadeCell layout hints. */
export const CHANGE_MADE_KIND = {
  ADDED: 'added',
  REMOVED: 'removed',
  FIELD_CHANGE: 'field_change',
  EDITED: 'edited',
  REORDERED: 'reordered',
  COVER_CHANGE: 'cover_change',
  /** Video row: request change shows "Link to video" + icon-ir. */
  LINK: 'link',
};
